import { formatAccountNumber, toLegacyAccountNumber } from "@/lib/account-number";
import type { SessionContext } from "@/iframe/postMessage";

/** OneAgent placeholder when no business account is selected yet. */
export const PENDING_HOST_ACCOUNT_REF = "OE-PENDING";

const ONEVIEW_ACCOUNT_RESOURCE_PATTERN =
  /^tenants\/[^/]+\/customers\/[^/]+\/accounts\/[^/]+$/;

export function isOneviewAccountResourceName(value: string): boolean {
  return ONEVIEW_ACCOUNT_RESOURCE_PATTERN.test(value.trim());
}

/**
 * Search string for `/api/search` from the host session context.
 * Returns null when the host has not selected an account yet.
 */
export function resolveHostAccountSearchQuery(sessionContext: SessionContext): string | null {
  if (sessionContext.__synthetic) return null;

  const resource = sessionContext.oneAgent?.accountResourceName?.trim();
  if (resource && isOneviewAccountResourceName(resource)) {
    return resource;
  }

  const ref = sessionContext.accountRef.trim();
  if (!ref || ref === PENDING_HOST_ACCOUNT_REF) return null;

  try {
    const legacy = toLegacyAccountNumber(ref);
    return formatAccountNumber(legacy);
  } catch {
    return ref;
  }
}
